<template>
  <el-tooltip class="item" effect="dark" content="Help" placement="bottom">
    <span @click="openHelp">
      <span class="help-icon">?</span>
    </span>
  </el-tooltip>
</template>

<script>
export default {
  methods: {
    openHelp() {
      window.open('https://help.csg.wooper.com/', '_blank', 'noopener,noreferrer');
    },
  },
};
</script>

<style scoped>
.help-icon {
  display: inline-block;
  width: 18px;
  height: 18px;
  border-radius: 2px;
  background-color: #5a5e66;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  text-align: center;
  vertical-align: -0.15em;
}
</style>
